import { useState, useMemo } from 'react'
import { Outlet, useNavigate, useLocation, Link as RouterLink } from 'react-router-dom'
import { MENU } from './menu'
import { useAuth } from '../auth/AuthContext'
import { getConfig } from '../config'
import Icon from '../components/Icon'

export default function AppShell() {
  const { auth, logout, can } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const cfg = getConfig()
  const [navOpen, setNavOpen] = useState(false)

  const grupos = MENU
    .map((g) => ({ ...g, items: g.items.filter((it) => !it.permission || can(it.permission)) }))
    .filter((g) => g.items.length > 0)

  const current = useMemo(() => {
    for (const g of MENU) for (const it of g.items) {
      if (location.pathname.startsWith(it.path)) return { section: g.section, label: it.label }
    }
    return { section: 'DPY', label: 'Inicio' }
  }, [location.pathname])

  const initials = (auth?.username || '?').slice(0, 2).toUpperCase()
  const go = (path) => { navigate(path); setNavOpen(false) }

  return (
    <div className={'app' + (navOpen ? ' nav-open' : '')}>
      <div className="sidebar-backdrop" onClick={() => setNavOpen(false)} />

      {/* Sidebar */}
      <aside className="sidebar">
        <div className="brand"><div className="brand-mark">D</div><span>DPY Ágil</span></div>
        <div className="nav-scroll">
          {grupos.map((g) => (
            <div key={g.section} className="nav-section">
              <div className="nav-label">{g.section}</div>
              {g.items.map((it) => {
                const active = location.pathname.startsWith(it.path)
                return (
                  <RouterLink key={it.path} to={it.path} onClick={() => setNavOpen(false)}
                    className={'nav-item' + (active ? ' active' : '')}>
                    <Icon name={it.icon} size={16} />
                    <span>{it.label}</span>
                    {it.badge != null && <span className="badge-pill">{it.badge}</span>}
                  </RouterLink>
                )
              })}
            </div>
          ))}
        </div>
        <div className="sidebar-footer">{cfg.brand} · Facturación Electrónica</div>
      </aside>

      {/* Main */}
      <div className="main">
        <div className="topbar">
          <button className="icon-btn mobile-menu-btn" onClick={() => setNavOpen(true)} aria-label="Menú">
            <Icon name="inventory" size={18} />
          </button>
          <div className="breadcrumb">
            <span>{current.section}</span><span className="sep">/</span><span className="current">{current.label}</span>
          </div>
          <div className="topbar-actions">
            <button className="icon-btn" title="Buscar"><Icon name="search" size={17} /></button>
            <button className="icon-btn has-dot" title="Notificaciones"><Icon name="bell" size={17} /></button>
            <div className="topbar-user">
              <div className="avatar">{initials}</div>
              <div>{auth?.username}</div>
              <button className="icon-btn" title="Cerrar sesión" onClick={async () => { await logout(); go('/login') }}>
                <Icon name="logout" size={16} />
              </button>
            </div>
          </div>
        </div>

        <div className={location.pathname.startsWith('/facturar') ? '' : 'page-pad'}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
